export default __webpack_public_path__ + "static/media/parameterGlobal.253bd750.svg";